import React from 'react';
import cn from 'classnames';
import * as Fi from 'react-icons/fi';

import { Select, DateRangePicker } from 'ui/components';
import { formatDate } from 'utilities/common';

const statusOptions = [
  { value: 'new', label: 'Baru' },
  { value: 'received', label: 'Sudah Diterima' },
];

const initialState = {
  status: null,
  created: null,
};


const Filter = ({ show, onClose, ReceivingTable, setCount }) => {
  const [{ status, created }, setState] = React.useState(initialState);

  const $onLoad = async () => {
    let date = [];

    if (
      ReceivingTable.State?.filter?.start_at &&
      ReceivingTable.State?.filter?.end_at
    ) {
      const x = ReceivingTable.State?.filter?.start_at;

      date.push(new Date(x));

      const y = ReceivingTable.State?.filter?.end_at;
      date.push(new Date(y));
      setState((prevState) => ({
        ...prevState,
        created: date,
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        created: null,
      }));
    }

    setState((prevState) => ({
      ...prevState,
      status:
        ReceivingTable?.State?.filter?.document_status === 'new'
          ? statusOptions[0]
          : ReceivingTable?.State?.filter?.document_status === 'checked'
          ? statusOptions[1]
          : ReceivingTable?.State?.filter?.document_status === 'completed'
          ? statusOptions[2]
          : null,
    }));
  };

  const handleFilter = async (e) => {
    if (ReceivingTable?.State?.filter) {
      let x = [];
      Object.keys(ReceivingTable?.State?.filter).forEach((k) => {
        if (
          ReceivingTable?.State?.filter[k] &&
          k !== 'start_at'
        ) {
          x.push(k);
        }
      });

      setCount(x);
    }
  };

  const handleStatus = (e) => {
    setState((prevState) => ({
      ...prevState,
      status: e,
    }));
    ReceivingTable.filter('document_status', e?.value);
    handleFilter();
  };

  React.useEffect(() => {
    $onLoad();
  }, []);

  React.useEffect(() => {
    handleFilter();
  }, []);

  return (
    <>
      <div
        className={cn(
          show
            ? 'col-md-3 d-none d-md-block py-3 px-3 m-0 border-start'
            : 'd-none'
        )}
      >
        <div className="mb-3 border-bottom">
          <div className="d-flex align-items-center justify-content-between">
            <div className="page-pretitle fs-7 text-secondary">Filter</div>
            <div className="mt-n1">
              <button className="btn btn-action-close " onClick={onClose}>
                <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
              </button>
            </div>
          </div>
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">
            Status
          </div>
          <Select
            placeholder=""
            classNamePrefix="select"
            isClearable
            options={statusOptions}
            value={status}
            onChange={handleStatus}
          />
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">
            Jadwal Receiving
          </div>
          <DateRangePicker
            value={created}
            placeholder=""
            onChange={(date) => {
              setState((prevState) => ({
                ...prevState,
                created: date,
              }));
              let fm = [];
              date?.forEach((data) => fm?.push(formatDate(data, 'YYYY-MM-DD')));
              if (fm?.length > 0) {
                ReceivingTable.filter('start_at', fm[0]);
                ReceivingTable.filter('end_at', fm[1]);
                handleFilter();
              } else {
                ReceivingTable.filter('start_at', null);
                ReceivingTable.filter('end_at', null);
                handleFilter();
              }
            }}
          />
        </div>
      </div>

      <>
        <div
          className={cn('filter-overlay', show ? 'd-block d-md-none' : '')}
          onClick={onClose}
        />
        <div
          className={cn(
            'filter-modal d-block d-md-none py-3',
            show ? 'filter-show' : ''
          )}
        >
          <div className="mb-3 border-bottom">
            <div className="d-flex align-items-center justify-content-between">
              <div className="page-pretitle fs-7 text-secondary">Filter</div>
              <div className="mt-n1">
                <button className="btn btn-action-close " onClick={onClose}>
                  <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
                </button>
              </div>
            </div>
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">
              Status
            </div>
            <Select
              placeholder=""
              classNamePrefix="select"
              isClearable
              options={statusOptions}
              value={status}
              onChange={handleStatus}
            />
          </div>

          <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">
            Jadwal Fulfillment
          </div>
          <DateRangePicker
            value={created}
            placeholder=""
            onChange={(date) => {
              setState((prevState) => ({
                ...prevState,
                created: date,
              }));
              let fm = [];
              date?.forEach((data) => fm?.push(formatDate(data, 'YYYY-MM-DD')));
              if (fm?.length > 0) {
                ReceivingTable.filter('start_at', fm[0]);
                ReceivingTable.filter('end_at', fm[1]);
                handleFilter();
              } else {
                ReceivingTable.filter('start_at', null);
                ReceivingTable.filter('end_at', null);
                handleFilter();
              }
            }}
          />
        </div>


        </div>
      </>
    </>
  );
};

export default Filter;
